import VARS from '@/lib/vars'
import URL from '@/lib/url'
import native from '@zz-common/native-adapter'
// @ts-ignore
import { legic } from '@/lib/legic.ts'
import { cookie } from '@zz-common/zz-utils'

/**
 * 用于获取pageType
 */
export const getPageType = () => {
  let pageType = VARS.legoPrefix + 'DEFAULT_PAGETYPE'
  let pathName = window.location.pathname
  if (pathName) {
    pathName = pathName.split(`${VARS.routerBase}/`)[1]
    // 为首页
    if (pathName === '') {
      pageType = VARS.legoPrefix + 'HOME'
    } else {
      pageType = VARS.legoPrefix + cutPath(pathName).replace(/\//gi, '_')
    }
  }
  pageType = pageType.toUpperCase()
  return pageType
}

/**
 * 去掉路径重的 \\s \\d
 * 正常路径中不能含有[a-zA-Z]_- 之外的东西，不能有数字
 * @param pathName 路径字符串
 */
const cutPath = (pathName) => {
  const pathReg = /[a-zA-Z_-]+/gi
  const pathNameArr = pathName.split('/')
  return pathNameArr
    .map((pathStr) => {
      let arr = null
      let path = ''
      while ((arr = pathReg.exec(pathStr)) !== null) {
        path += arr[0]
      }
      return path
    })
    .join('/')
}

/**
 * 分享出去需要做的一些通用方法（包括分享到小程序），设置 fromActiontype、分享成功的埋点
 * @param shareProperty 分享方法，例如 shareToPlatform setSharePanel等
 * @param shareParam 分享方法的参数
 * @param shareCallBack 分享成功后的回调函数
 */
export const shareCommonFn = (shareProperty: string, shareParam: any, shareCallBack?) => {
  let actionType = 'DEFAULT_SHARE'
  const pageType = getPageType()
  // 设置渠道号
  const channel = VARS.channel + '_share'
  const shareObj = Object.assign({}, shareParam)
  if (shareObj.miniAppShare) {
    actionType = shareObj.miniAppShare.actionType || actionType
    // 设置 fromActiontype
    shareObj.miniAppShare.path = URL.setHashParam(
      shareObj.miniAppShare.path,
      'fromActiontype',
      `${pageType}_H5CHECKIN_${actionType}`
    )
    shareObj.miniAppShare.path = URL.setHashParam(shareObj.miniAppShare.path, 'channel', channel)
  }
  // 自动补齐前缀
  if (actionType.toLowerCase().indexOf(VARS.legoPrefix) === -1) {
    actionType = VARS.legoPrefix + actionType
  }

  console.log('shareObj', shareObj)
  if (!VARS.isWXWebviewFn()) {
    // 小程序中只配置了 act.zhuanzhuan.com 一个业务域名，不再变化地址
    shareObj.url = `https://app.zhuanzhuan.com/zz/redirect/commonUrlRedirect?businessType=2&path=${encodeURIComponent(
      shareObj.url
    )}`
  }
  native.wrap(shareProperty)(shareObj, (res) => {
    if (res && res.code === '0') {
      // 分享成功的埋点
      legic('H5CHECKIN_SHARE_SUCCESS', { actionType: actionType.toUpperCase(), channel })
    }
    shareCallBack && shareCallBack(res)
  })
}

/**
 * 判断是否是转转
 */
export const isZhuanZhuan = () => {
  const ua = window.navigator.userAgent
  return ua.toLowerCase().indexOf('zhuanzhuan') > 0
}

/**
 * 提取图片地址最后的图片名字
 * @param url 图片地址
 */
export const picUrlSlice = (url: string) => {
  const domainReg = /(58cdn.com)|(zhuanstatic.com)/i
  const picReg = /(\w*(\.png|\.jpg|\.gif|\.jpeg|\.bmp))/i
  if (domainReg.test(url) && picReg.test(url)) {
    const ma = picReg.exec(url)
    return ma[1]
  } else {
    return url
  }
}

/**
 * 时间戳格式化 09:23:00
 */
export const dateFormat = (milliseconds, format = 'hh:mm:ss') => {
  const date = new Date(Number(milliseconds))
  const set = {
    'Y+': date.getFullYear(),
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  if (/(Y+)/.test(format)) {
    format = format.replace(RegExp.$1, date.getFullYear() + '')
  }
  for (const key in set) {
    if (new RegExp(`(${key})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? set[key] : ('00' + set[key]).substr(('' + set[key]).length)
      )
    }
  }
  return format
}

export const scroll = (option = 0, target, duration = 30) => {
  let stepCount = 0
  let x
  let y
  typeof option === 'number' ? (y = option) : ({ x, y } = option)
  const stepPI = Math.PI / duration
  const initialPosition = {
    x: target ? target.scrollLeft : scrollX,
    y: target ? target.scrollTop : scrollY
  }

  target = target || window

  if (!target.scrollTo) return
  if (!window.requestAnimationFrame) return window.scrollTo(x, y)

  const step = () => {
    if (stepCount < duration) {
      requestAnimationFrame(step)
      stepCount++
      const coefficient = 0.25 * Math.pow(1 - Math.cos(stepPI * stepCount), 2)
      target.scrollTo(
        x ? initialPosition.x + (x - initialPosition.x) * coefficient : 0,
        y ? initialPosition.y + (y - initialPosition.y) * coefficient : 0
      )
    }
  }
  requestAnimationFrame(step)
}

export const indexInParent = (node, query) => {
  node = Array.isArray(node) ? node.find((e) => e.classList.contains(query)) : node
  const children = node.parentNode.childNodes
  let num = 0
  for (let i = 0; i < children.length; i++) {
    if (children[i] === node) return num
    if (children[i].nodeType === 1) num++
  }
  return -1
}

/**
 * @memberOf util
 * @summary 倒计时
 * @type {function}
 * @param {object}    countDownInfo    (必)
 *                          - endTime            {string}   (必) 结束时间
 *                          - currentTime        {string}   (可) 当前时间
 *                          - leftTime           {string}   (可) 倒计时时间差
 * @param {blone}     hasMs            (可)  - 是否含有毫秒)
 * @param {function}  countDownCB      (可)  - 倒计时变化的回调)
 * @param {function}  endCB            (可)  - 倒计时结束后的回调)
 * @return {object}                - 倒计时时间
 */
export const countDown = (
  { endTime = '', currentTime = new Date().getTime(), leftTime }: any,
  countDownCB?: any,
  endCB?: any,
  hasMs?: boolean
) => {
  if (!leftTime) {
    leftTime = Number(endTime) - Number(currentTime)
  }
  let timer = null
  const step = hasMs ? 100 : 1000
  if (leftTime > 0) {
    timer = setInterval(() => {
      if (leftTime <= 0) {
        // this.timeOut = {}
        clearInterval(timer)
        endCB && endCB(timer)
      } else {
        leftTime -= step
        countDownCB && countDownCB(timeProcess(leftTime), timer)
      }
    }, step)
  }
}
function formatNumber(n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}
function timeProcess(times) {
  let newTimes = {}
  if (times > 0) {
    let temp = 0
    const day = Math.floor(times / (24 * 60 * 60 * 1000))
    temp = day * 24 * 60 * 60 * 1000
    const hours = Math.floor((times - temp) / (60 * 60 * 1000))
    temp = day * 24 * 60 * 60 * 1000 + hours * 60 * 60 * 1000
    const minutes = Math.floor((times - temp) / (60 * 1000))
    temp = day * 24 * 60 * 60 * 1000 + hours * 60 * 60 * 1000 + minutes * 60 * 1000
    const seconds = Math.floor((times - temp) / 1000)
    temp = day * 24 * 60 * 60 * 1000 + hours * 60 * 60 * 1000 + minutes * 60 * 1000 + seconds * 1000
    const ms = Math.floor((times - temp) / 100)
    newTimes = {
      day: formatNumber(day),
      hours: formatNumber(hours),
      minutes: formatNumber(minutes),
      seconds: formatNumber(seconds),
      ms
    }
  }
  return newTimes
}

// 商品图片 通常是 后缀，以“｜”分割的字符串，按“｜”截取后取第一个并补全
export const composePicPath = (value: string) => {
  const domainReg = /(58cdn.com)|(zhuanstatic.com)/i
  if (!value) {
    return ''
  }
  if (domainReg.test(value)) {
    return value
  } else {
    const arr = value.split('|')[0]
    if (arr) {
      return `https://pic${
        Math.floor(Math.random() * Math.floor(6)) + 1
      }.zhuanstatic.com/zhuanzh/${arr}`
    } else {
      return ''
    }
  }
}

export const fenToYuan = (priceInt) => {
  if (priceInt % 100 === 0) {
    return priceInt / 100
  }
  return (priceInt / 100).toFixed(2)
}

// 判断是否是半屏ios
export const isIphoneXAndHalfVer = () => {
  return URL.getQueryParam('wvHalfVer') && VARS.isIphoneX
}

// 通过第三方埋点测试lego准确性 - 已下掉
export const otherIOInit = (type = 'huoshan') => {
  // 初始化诸葛IO
  const script = document.createElement('script')
  // 诸葛IO
  if (type == 'zhuge') {
    script.innerHTML = `
      try {
        (function() {
          if (window.zhuge) return;
          window.zhuge = [];
          window.zhuge.methods = "_init identify track trackRevenue getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform".split(" ");
          window.zhuge.factory = function(b) {
            return function() {
              var a = Array.prototype.slice.call(arguments);
              a.unshift(b);
              window.zhuge.push(a);
              return window.zhuge;
            }
          };
          for (var i = 0; i < window.zhuge.methods.length; i++) {
            var key = window.zhuge.methods[i];
            window.zhuge[key] = window.zhuge.factory(key);
          }
          window.zhuge.load = function(b, x) {
            if (!document.getElementById("zhuge-js")) {
              var a = document.createElement("script");
              var verDate = new Date();
              var verStr = verDate.getFullYear().toString() + verDate.getMonth().toString() + verDate.getDate().toString();

              a.type = "text/javascript";
              a.id = "zhuge-js";
              a.async = !0;
              a.src = 'https://su.zhugeio.com/zhuge.js?v=' + verStr;
              a.onerror = function() {
                window.zhuge.identify = window.zhuge.track = function(ename, props, callback) {
                  if(callback && Object.prototype.toString.call(callback) === '[object Function]') {
                    callback();
                  } else if (Object.prototype.toString.call(props) === '[object Function]') {
                    props();
                  }
                };
              };
              var c = document.getElementsByTagName("script")[0];
              c.parentNode.insertBefore(a, c);
              window.zhuge._init(b, x)
            }
          };
          window.zhuge.load('ef91603e72464bb982cb8efcaba2c37e', { //配置应用的AppKey
            superProperty: { //全局的事件属性(选填)
              '应用名称': '诸葛数据分析'
            },
            adTrack: false,//广告监测开关，默认为false
            zgsee: false,//视屏采集开关， 默认为false
            autoTrack: false,
            //启用全埋点采集（选填，默认false）
            singlePage: false //是否是单页面应用（SPA），启用autoTrack后生效（选填，默认false）
          });
        })();
      } catch (error) {
        console.log(error)
      }
    `
  }
  // 火山引擎
  if (type == 'huoshan') {
    script.innerHTML = `
      try {
        (function(win, export_obj) {
          win['TeaAnalyticsObject'] = export_obj;
          if (!win[export_obj]) {
              function _collect() {
                  _collect.q.push(arguments);
              }
              _collect.q = _collect.q || [];
              win[export_obj] = _collect;
          }
          win[export_obj].l = +new Date();
      })(window, 'collectEvent');
      } catch (error) {
        console.log(error)
      }
    `
  }
  // 将 <script> 元素插入到文档的 <head> 元素中
  document.head.appendChild(script)
  if (type == 'huoshan') {
    const scriptHuoshan = document.createElement('script')
    scriptHuoshan.setAttribute('src', 'https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.9.js')
    // scriptHuoshan.setAttribute('async', '')
    document.head.appendChild(scriptHuoshan)
  }
}

export const token = cookie.get('tk') || cookie.getUid() || cookie.get('idzz') || cookie.get('id58') || 'token_not_found'